module.exports = __webpack_public_path__ + "static/media/InvoiceTotal.d78afd4c.jpg";